import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const TestAuth = () => {
  const { user, loading: authLoading } = useAuth();

  return (
    <div style={{ padding: '20px' }}>
      <h1>Authentication Test</h1>
      <p><strong>Auth Loading:</strong> {authLoading ? 'true' : 'false'}</p>
      <p><strong>User:</strong> {user ? JSON.stringify(user) : 'null'}</p>
      <p><strong>User exists:</strong> {user ? 'true' : 'false'}</p>
    </div>
  );
};

export default TestAuth;
